import React from 'react'
import {observer} from 'mobx-react-lite'
import {HeartFilledIcon, HeartIcon} from '../../icons'
import {BaseButton, BaseButtonProps} from '../../../vanilla/components/BaseButton'
import {addToFavouritesButton} from './styles.css'
import useWishlistItem from '../../../store/hooks/useWishlistItem'
import {useAlgoliaAnalytics} from '../../../contexts'

interface AddToFavouritesButton extends BaseButtonProps<'button'> {
  productid: string
  autocompleteQueryID?: string
}

export const AddToFavouritesButton = observer((props: AddToFavouritesButton) => {
  const {productid, autocompleteQueryID} = props

  const {events} = useAlgoliaAnalytics()
  const {handleRemoveWishlistItem, isInWishlist, handleAddWishlistItem} = useWishlistItem(productid)

  const toggleWishlist = async () => {
    if (isInWishlist) {
      handleRemoveWishlistItem()
      return
    }

    await handleAddWishlistItem()

    const navigatedThroughSearchResults = Boolean(autocompleteQueryID)

    /** Algolia Analytics events  **/
    if (navigatedThroughSearchResults) {
      events?.productListPage?.sendAddToFavouriteAfterSearchEvent({
        queryID: autocompleteQueryID,
        objectIDs: [productid],
      })
    } else {
      events?.productListPage.sendAddToFavouriteEvent({
        objectIDs: [productid],
      })
    }
  }

  return (
    <BaseButton
      aria-label="Add to favourites"
      className={addToFavouritesButton}
      onClick={toggleWishlist}
      {...props}
      paddingX="0px"
      width="20px"
      height="20px"
    >
      {isInWishlist ? (
        <HeartFilledIcon color="accent0" boxSize="20px" />
      ) : (
        <HeartIcon color={{default: 'black', hover: 'accent0'}} boxSize="20px" />
      )}
    </BaseButton>
  )
})
